import { Routes } from '@angular/router';

import { TargetingResultsComponent } from '../../Targeting/components/TargetingResults/targeting-results.component';
import { ContactEditorComponent } from '../../../Common/RhpContexts/components/ContactEditor/contact-editor.component';
import { ContactImporterComponent } from '../../Targeting/components/ContactImporter/contact-importer.component';


export const privateContactRoutes: Routes = [
    {
        path: '',
        component: TargetingResultsComponent,
        data: {title: 'Discover.contacts.browserTitle'}
    },
    {
        path: 'editor',
        component: ContactEditorComponent,
        data: {title: 'Discover.createContact.browserTitle'}
    },
    {
        path: 'editor/:id',
        component: ContactEditorComponent,
        data: {title: 'Discover.editContact.browserTitle'}
    },
    {
        path: 'csvimport',
        component: ContactImporterComponent,
        data: {title: 'Discover.importContacts.browserTitle'}
    },
    {
        path: '**',
        redirectTo: '/Discover/privatecontacts'
    }
];
